import PropTypes from 'prop-types';

import { stepsFactory } from 'components/Booking-new/utils/steps';
import { paddingsPropTypes, gatsbyImageDataShape } from '../propTypes';

import SummaryContainer from './SummaryContainer';

import VariantA from './Variants/VariantA';

const summaryVariants = {
  a: VariantA,
};

const summaryStepWrapper = SummaryContainer;

const Summary = ({ variant, data, navigation, userData }) => {
  return stepsFactory(summaryVariants, variant, { data, navigation, userData }, summaryStepWrapper);
};

Summary.propTypes = {
  variant: PropTypes.oneOf(['a']),
  data: PropTypes.shape({
    __typename: PropTypes.string,
    body: PropTypes.arrayOf(
      PropTypes.shape({
        __typename: PropTypes.string,
        faqs: PropTypes.arrayOf(
          PropTypes.shape({
            contentRt: PropTypes.shape({
              raw: PropTypes.string,
              references: PropTypes.arrayOf(PropTypes.any),
            }),
            heading: PropTypes.string,
            id: PropTypes.string,
            isOpenedByDefault: PropTypes.bool,
          }),
        ),
        headingSection: PropTypes.any,
        id: PropTypes.string,
        link: PropTypes.any,
        paddings: paddingsPropTypes,
      }),
    ),
    googleButtonLabel: PropTypes.string,
    iCalButtonLabel: PropTypes.string,
    id: PropTypes.string,
    isNextStep: PropTypes.bool,
    isPrevStep: PropTypes.bool,
    localImage: PropTypes.shape({
      id: PropTypes.string,
      localFile: PropTypes.shape({
        childImageSharp: PropTypes.shape({
          gatsbyImageData: gatsbyImageDataShape,
        }),
      }),
      title: PropTypes.string,
    }),
    name: PropTypes.string,
    surveyAfterBooking: PropTypes.shape({
      __typename: PropTypes.string,
      hasDelay: PropTypes.bool,
      id: PropTypes.string,
      successImage: PropTypes.shape({
        file: PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
      successMessage: PropTypes.string,
      typeformLiveId: PropTypes.string,
      surveyOptionsList: PropTypes.shape({
        optionsList: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string,
            name: PropTypes.string,
          }),
        ),
      }),
      title: PropTypes.string,
    }),
    title: PropTypes.string,
  }),
};

export default Summary;
